import { render, staticRenderFns } from "./flowCarousel.vue?vue&type=template&id=538d6e2f&scoped=true&"
import script from "./flowCarousel.vue?vue&type=script&lang=js&"
export * from "./flowCarousel.vue?vue&type=script&lang=js&"
import style0 from "./flowCarousel.vue?vue&type=style&index=0&id=538d6e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d6e2f",
  null
  
)

export default component.exports